module.exports = __webpack_public_path__ + "static/media/Result-Not-Available.3f090304.svg";